import { Title } from '../../shared/title';
import { Wrapper } from '../../shared/wrapper';
import { useMediaQuery } from 'react-responsive';
import { useTranslations } from 'next-intl';
import ProgressiveImage from 'react-progressive-image';
import { FC, memo } from 'react';
import LazyImage from '../LazyImage';
import { styled } from '../../shared/styles';

let Nft: FC<{ className?: string }> = ({ className }) => {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const t = useTranslations();

  return (
    <article className={className}>
      <LazyImage className='nft_left' src={'/images/webp/nft_left.webp'} alt='nft_left' />
      <Wrapper>
        <Title title={t('nft.title')} />
        <div className='flex nft_flex'>
          <div className='nft_list'>
            <div className='nft_item flex'>
              <div>
                <LazyImage src={'/images/webp/nft_1.webp'} alt='nft_1' />
              </div>
              <p>{t('nft.text1')}</p>
            </div>
            <div className='nft_item flex'>
              <div>
                <LazyImage src={'/images/webp/nft_2.webp'} alt='nft_2' />
              </div>

              <p>{t('nft.text2')}</p>
            </div>
            <div className='nft_item flex'>
              <div>
                <LazyImage src={'/images/webp/nft_3.webp'} alt='nft_3' />
              </div>

              <p>{t('nft.text3')}</p>
            </div>
            <div className='nft_item flex'>
              <div>
                <LazyImage src={'/images/webp/nft_4.webp'} alt='nft_4' />
              </div>

              <p>{t('nft.text4')}</p>
            </div>
          </div>
          {/* <LazyImage className='nft_card' src={nft} alt='nft' />
          <LazyImage className='nft_card_tablet' src={nft_tablet} alt='nft_tablet' />
          <LazyImage className='nft_card_mobile' src={nft_mobile} alt='nft_mobile' /> */}
          <div className='nft_card'>
            <div className='nft_wrapper'>
              {/* @ts-ignore */}
              <ProgressiveImage src={'/images/webp/nft_card_1.webp'} placeholder={'/images/webp/nft_card_1_small.webp'}>
                {(src, loading) => (
                  <img
                    src={src}
                    loading='lazy'
                    alt='nft_card_1'
                    className='nft_card_1'
                    style={{
                      filter: loading ? 'blur(10px)' : 'none',
                      transition: 'filter 0.3s ease-out'
                    }}
                  />
                )}
              </ProgressiveImage>
              {/* @ts-ignore */}
              <ProgressiveImage src={'/images/webp/nft_card_3.webp'} placeholder={'/images/webp/nft_card_2_small.webp'}>
                {(src, loading) => (
                  <img
                    src={src}
                    loading='lazy'
                    alt='nft_card_2'
                    className='nft_card_2'
                    style={{
                      filter: loading ? 'blur(10px)' : 'none',
                      transition: 'filter 0.3s ease-out'
                    }}
                  />
                )}
              </ProgressiveImage>
              {/* @ts-ignore */}
              <ProgressiveImage src={'/images/webp/nft_card_2.webp'} placeholder={'/images/webp/nft_card_3_small.webp'}>
                {(src, loading) => (
                  <img
                    src={src}
                    loading='lazy'
                    alt='nft_card_3'
                    className='nft_card_3'
                    style={{
                      filter: loading ? 'blur(10px)' : 'none',
                      transition: 'filter 0.3s ease-out'
                    }}
                  />
                )}
              </ProgressiveImage>
            </div>
            {/* @ts-ignore */}
            <ProgressiveImage src={'/images/webp/nft_card_top.webp'} placeholder={'/images/webp/nft_card_top.webp'}>
              {(src, loading) => (
                <img
                  src={src}
                  loading='lazy'
                  alt='nft_card_top'
                  className='nft_card_top'
                  style={{
                    filter: loading ? 'blur(10px)' : 'none',
                    transition: 'filter 0.3s ease-out'
                  }}
                />
              )}
            </ProgressiveImage>
            {/* @ts-ignore */}
            <ProgressiveImage
              src={'/images/webp/nft_card_bottom.webp'}
              placeholder={'/images/webp/nft_card_bottom.webp'}
            >
              {(src, loading) => (
                <img
                  src={src}
                  loading='lazy'
                  alt='nft_card_bottom'
                  className='nft_card_bottom'
                  style={{
                    filter: loading ? 'blur(10px)' : 'none',
                    transition: 'filter 0.3s ease-out'
                  }}
                />
              )}
            </ProgressiveImage>
          </div>
        </div>
        <div className='coin flex'>
          <LazyImage
            className='coin_bg'
            src={isMobile ? '/images/webp/coin_bg_mobile.webp' : '/images/webp/coin_bg.webp'}
            alt='coin_bg_mobile'
          />
          <div className='coin_info'>
            <h2 className='coin_info_title'>{t('nft.coin_title')}</h2>
            <p className='coin_info_text_1'>
              <span>{t('nft.coin_text_colored')}</span> - {t('nft.coin_text')}
            </p>
            <br />
            <div className='coin_info_text_2'>
              <div style={{ color: 'white' }} className='coin_info_block'>
                {' '}
                {t('nft.coin_subtext')}
              </div>
              <div className='tokenPercents'>
                <div>
                  <span style={{ fontSize: '32px' }}>2.5%</span>
                  <p style={{ color: 'white' }}> {t('nft.coin_subtext1')}</p>
                </div>
                <div>
                  <span style={{ fontSize: '64px' }}>5%</span>
                  <p style={{ color: 'white' }}>{t('nft.coin_subtext2')}</p>
                </div>
                <div>
                  <span style={{ fontSize: '32px' }}>2.5%</span>
                  <p style={{ color: 'white' }}> {t('nft.coin_subtext3')}</p>
                </div>
              </div>
              {t('nft.coin_subtext4')}
            </div>
          </div>
          {/* @ts-ignore */}
          <ProgressiveImage src={'/images/webp/coin.webp'} placeholder={'/images/webp/coin_small.webp'}>
            {(src, loading) => (
              <img
                src={src}
                loading='lazy'
                alt='coin_img'
                className='coin_img'
                style={{
                  filter: loading ? 'blur(10px)' : 'none',
                  transition: 'filter 0.3s ease-out'
                }}
              />
            )}
          </ProgressiveImage>
        </div>
      </Wrapper>
    </article>
  );
};

Nft = styled(Nft, {
  '&': {
    marginTop: 0,
    position: 'relative',
    paddingTop: '49px',
    background: 'linear-gradient(180deg, #381131 0%, #141518 100%)',
    borderTopLeftRadius: '60px',
    borderTopRightRadius: '60px',
    overflow: 'hidden'
  },

  '& .nft_left': {
    position: 'absolute',
    left: 0,
    top: 0,
    '@toDesktop': {
      width: '162px',
      top: '-10px',
      left: '-10px'
    }
  },

  '& .nft_wrapper': {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    '@toDesktop': {
      width: '624px',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 1
    },
    '@toTablet': {
      transform: 'translateX(-50%) scale(0.8)'
    },
    '@to590': {
      transform: 'translateX(-50%) scale(0.5)',
      top: '-40px'
    }
  },
  '& .nft_card': {
    width: '624px',
    minWidth: '624px',
    height: '704px',
    display: 'block',
    position: 'relative',
    borderRadius: '44px',
    overflow: 'hidden',

    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      borderRadius: '44px',
      padding: '2px',
      background: 'linear-gradient(to top right, #26174d 0%, #a6f14b 100%)',
      '-webkit-mask': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
      '-webkit-mask-composite': 'destination-out',
      'mask-composite': 'exclude',
      pointerEvents: 'none',
      zIndex: 2,
      '@toTablet': {
        borderRadius: '23px'
      }
    },
    '@toDesktop': {
      // height: 378px,
      width: '100%',
      minWidth: 'min-content',
      display: 'flex',
      height: '564px'
    },
    '@toTablet': {
      borderRadius: '23px',
      height: '430px'
    },
    '@to590': {
      height: '276px'
    },
    '& .nft_card_top': {
      position: 'absolute',
      top: 0,
      left: 0,
      '@toDesktop': {
        // display: none,
        width: '100%'
      }
    },
    '& .nft_card_bottom': {
      position: 'absolute',
      bottom: 0,
      left: 0,
      '@toDesktop': {
        width: '100%'
      }
    },
    '& .nft_card_1': {
      position: 'absolute',
      top: '153px',
      left: '18px',
      width: '252px',
      height: '398px',
      zIndex: 1,
      '@toDesktop': {
        top: '83px'
      },
      '@toTablet': {
        top: 'calc(83px - 64px)'
      }
    },
    '& .nft_card_2': {
      position: 'absolute',
      width: '276px',
      height: '436px',
      top: '134px',
      left: '227px',
      zIndex: 3,
      '@toDesktop': {
        top: '64px'
      },
      '@toTablet': {
        top: 0
      }
    },
    '& .nft_card_3': {
      position: 'absolute',
      width: '192.5px',
      height: '304px',
      top: '200px',
      right: '20px',
      zIndex: 2,
      '@toDesktop': {
        top: '130px'
      },
      '@toTablet': {
        top: 'calc(130px - 64px)'
      }
    }
  },
  '& .coin': {
    position: 'relative',
    borderRadius: '40px',
    overflow: 'hidden',
    padding: '50px',
    justifyContent: 'space-between',
    marginTop: '147px',
    '@to1920': {
      marginTop: 'calc(120px + 27px)'
    },
    '@toXL': {
      marginTop: 'calc(120px + 21px)'
    },
    '@toDesktop': {
      flexDirection: 'column',
      marginTop: 'calc(120px + 22px)',
      padding: '40px'
    },
    '@toMedium': {
      marginTop: '145px'
    },
    '@toTablet': {
      // marginTop: 101,
      padding: '35px'
    },
    '@to576': {
      padding: '20px'
    },
    '@from2200': {
      marginTop: '145px'
    }
  },

  '& .coin_bg': {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%'
  },

  '& .coin_img': {
    width: 'auto',
    height: '80%',
    position: 'relative',
    '@toDesktop': {
      width: '371px',
      height: '367px',
      marginTop: '12px'
    },
    '@toTablet': {
      width: '293px',
      height: '291px',
      marginTop: '24px'
    }
  },
  '& .coin_info': {
    maxWidth: '50%',
    position: 'relative',
    marginTop: '-20px',
    textAlign: 'center',
    '@toDesktop': {
      marginTop: 0,
      maxWidth: '80%'
    },

    '@toTablet': {
      marginTop: 0,
      maxWidth: '100%'
    },

    '&_title': {
      fontSize: '44px',
      lineHeight: '170%',
      fontWeight: 600,
      color: 'white',
      marginBottom: '40px',

      '@toDesktop': {
        fontSize: '38px',
        lineHeight: '120%'
      },
      '@to500': {
        marginBottom: '20px'
      }
    },
    '&_block': {
      borderRadius: '20px',
      padding: '20px',
      paddingBottom: '70px',
      textAlign: 'center',
      background: 'linear-gradient(to bottom, #3d2b60, transparent)',
      marginBottom: '16px'
    },
    '& .coin_info_text': {
      '&_1': {
        span: {
          color: '#db4a71',
          fontWeight: 'bold'
        },
        marginTop: '6px',
        fontSize: '22px',
        color: 'white',
        lineHeight: '130%',
        '@toDesktop': {
          marginTop: '24px',
          maxWidth: 'max-content'
        }
      },
      '&_2': {
        span: {
          color: '#db4a71',
          fontWeight: 'bold'
        },
        marginTop: '16px',
        color: '#afa5b8',
        fontSize: '18px',
        lineHeight: '150%',
        '@toDesktop': {
          marginTop: '24px',
          maxWidth: 'max-content'
        }
      }
    }
  },

  '& .tokenPercents': {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '20px',
    width: '100%',
    textAlign: 'center',
    alignItems: 'center',
    marginBottom: '40px',

    p: {
      fontSize: '16px'
    },

    '@to500': {
      gridTemplateColumns: '1fr',
      gridTemplateAreas: `'second'
      'first'
      'third'`,

      '> :nth-child(1)': {
        gridArea: 'first'
      },

      '> :nth-child(2)': {
        gridArea: 'second'
      },

      '> :nth-child(3)': {
        gridArea: 'third'
      },
      gap: '32px',
      marginBottom: '20px'
    }
  },
  '& .nft_flex': {
    gap: '52px',
    marginTop: '64px',
    '@toXL': {
      marginTop: '56px'
    },
    '@toDesktop': {
      flexDirection: 'column',
      marginTop: '32px'
    },
    '@toTablet': {
      gap: '44px',
      marginTop: '40px'
    }
  },

  '& .nft_list': {
    display: 'flex',
    flexDirection: 'column',
    gap: '44px',
    '@toDesktop': {
      gap: '32px'
    }
  },
  '& .nft_item': {
    gap: '41px',
    '@toDesktop': {
      gap: '12px'
    },
    '@toTablet': {
      alignItems: 'start'
    },
    div: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '100%',
      border: '1px solid #ff86bb',
      width: '121px',
      height: '121px',
      minWidth: '121px',
      minHeight: '121px',
      '@toXL': {
        width: '91px',
        height: '91px',
        minWidth: '91px',
        minHeight: '91px'
      },
      '@toDesktop': {
        width: '72px',
        height: '72px',
        minWidth: '72px',
        minHeight: '72px'
      },
      '@toTablet': {
        width: '64px',
        height: '64px',
        minWidth: '64px',
        minHeight: '64px'
      },
      img: {
        width: '95px',
        height: '95px',
        minWidth: '95px',
        minHeight: '95px',
        '@toXL': {
          width: '72px',
          height: '72px',
          minWidth: '72px',
          minHeight: '72px'
        }
      }
    },
    p: {
      lineHeight: '120%',
      color: 'white',
      fontSize: '24px',
      '@toXL': {
        fontSize: '18px'
      }
    }
  }
});

export default memo(Nft);
